export const BUSINESS_PERCENT = {
  LIFE: 0,
  WORK: 1,
};

export const EXPANSES_LABELS = {
  BUSINESS: 'EXPANSES_LABELS_BUSINESS',
  PERSONAL: 'EXPANSES_LABELS_PERSONAL',
} as const;

export const ANIMATION_TIMEOUT = 500;

export const CURRENT_TRANSACTION_INDEX = 0;

export const EXPENSES_STYLES = {
  MAIN_CONTENT:
    'flex flex-col bg-bw00 justify-between items-center rounded-xl w-[46.5rem] h-[35rem] py-10 px-24 overflow-hidden',
  PERIOD_DETAILS: {
    CONTAINER: 'text-center',
    MAIN_HEADER: 'font-metricMedium text-xl text-bw08',
    SUB_HEADER: 'text-sm text-bw07 mt-4',
  },
  CATEGORIZATION_SECTION: {
    CONTAINER: 'flex min-h-64 min-w-[27rem] items-center',
    BUTTON_CONTAINER: 'h-14 w-14 shadow rounded-full flex justify-center items-center shadow-rotatedCard',
    CARD_CONTAINER: 'w-full h-full flex flex-col text-center items-center justify-center p-4 bg-bw02 rounded-lg',
    CATEGORY_IMAGE: 'h-[50%] w-[50%]',
    CARD_TRANSACTION_DETAILS_CONTAINER: 'flex flex-col justify-center items-center w-3/4 py-2 h-full justify-between',
    CARD_TRANSACTION_DETAILS_INNER_CONTAINER: 'flex justify-center text-sm gap-2',
    CARD_TRANSACTION_DETAILS_INNER_TEXT: 'flex w-full',
    BUSINESS_NAME: 'font-metricMedium text-bw08 overflow-hidden whitespace-nowrap text-ellipsis',
    TRANSACTION_AMOUNT: 'font-metricMedium text-bw08',
    TRANSACTION_DATE_AND_CATEGORY: 'text-bw07 text-3.5',
    CATEGORIZATION_DONE: 'flex flex-col justify-center items-center gap-4',
  },
  SUB_CONTENT: {
    CONTAINER: 'flex flex-col items-center bg-bw00 rounded-xl w-[22.5rem] p-10 h-fit',
  },
  SPINNER_COLOR: '#64C4CE',
  ICON_WIDTH: 30,
  ICON_HEIGHT: 26,
};

export const CATEGORIZATION_DATA = {
  PAGE_HEADER: 'EXPENSE_REPORTS_PAGE_HEADER',
  HEADER: {
    PART_1: 'CATEGORIZATION_HEADER_1',
    PART_2: 'CATEGORIZATION_HEADER_2',
    PART_3: 'CATEGORIZATION_HEADER_3',
  },
  TEXT: {
    PART_1: 'CATEGORIZATION_TEXT_1',
    PART_2: 'CATEGORIZATION_TEXT_2',
    PART_3: 'CATEGORIZATION_TEXT_3',
  },
  ERROR_MESSAGE: 'CATEGORIZATION_ERROR_MESSAGE',
  TRANSACTIONS_LEFT: 'CATEGORIZE_EXPENSES_COMPONENT_TRANSACTIONS_LEFT',
  ONE_TRANSACTION_LEFT: 'CATEGORIZE_EXPENSES_COMPONENT_ONE_TRANSACTION_LEFT',
  CATEGORIZATION_FINISHED_MESSAGE: 'CATEGORIZATION_FINISHED_MESSAGE',
};
